import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  height: theme.typography.pxToRem(800),
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.down('lg')]: {
    height: theme.typography.pxToRem(700),
    paddingBottom: theme.spacing(8),
  },
   [theme.breakpoints.down('md')]: {
    height: theme.typography.pxToRem(700),
    paddingBottom: theme.spacing(4),
  },
  '& .RFASBackground': {
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 0,
  },

  '& .RFASGradient': {
   background: `linear-gradient(180deg,${theme.palette.background.primary} 0%, rgba(17, 17, 17, 0.30) 30%, rgba(17, 17, 17, 0.60) 60%, ${theme.palette.background.primary} 100%)`,
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 1,
  },
'& .RFASContentContainer':{
      height: '100%',
},
  '& .RFASContent': {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end',
    alignItems: 'start',
    textAlign: 'start',
    maxWidth: theme.spacing(87.5),
    height: '100%',
    zIndex: 2,
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
  '& .RFASBtn':{
    minWidth: theme.spacing(25),
  },
}));

export default StyledBox;
